import News1 from "./../assets/News1.jpg";
import News2 from "./../assets/News2.jpg";
import News3 from "./../assets/News3.jpg";

const dashboardNews = [
  {
    title:
      "How Does “Minimizing Drawdown” Affect Your Long-Term Financial Goals?",
    text: "Financial advisors will often use terms like “acceptable losses” and “historical market trends” when describing why your investment portfolio is down. They’ll describe the model they’re using and explain how it matches your risk profile,",
    photo: News1,
    newsLink:
      "https://tactivewealth.com/how-does-minimizing-drawdown-affect-your-long-term-financial-goals/",
    id: 1,
  },
  {
    title:
      "Does Passive Investing Still Work in Post-Pandemic America’s “New Normal”?",
    text: "The world has changed. Most people have accepted that we are living in a “new normal” that is very different from what we once knew. Economically, we’re still struggling to get back on track.",
    photo: News2,
    newsLink:
      "https://tactivewealth.com/does-passive-investing-still-work-in-post-pandemic-americas-new-normal/",
    id: 2,
  },
  {
    title: "Robo-Advisors aren’t the problem. Your models are.",
    text: "Author John C. Maxwell is credited with the phrase, “Change is inevitable. Growth is optional.” His words were used to describe the human capacity for growth in an evolving life situation. We’re going to apply them to investing",
    photo: News3,
    newsLink:
      "https://tactivewealth.com/robo-advisors-arent-the-problem-your-models-are/",
    id: 3,
  },
];

export default dashboardNews;
